import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { defs } from '../defs';

@Injectable()
export class MySwarmQueryResolve implements Resolve<any> {
	constructor(private router: Router) {}

	resolve(route: ActivatedRouteSnapshot) {
		const parsedQueryParams = JSON.parse(localStorage.getItem(defs.mySwarmFilter));
		if (!Object.keys(route.queryParams).length && parsedQueryParams) {
			const { ownerId, ...queryParams } = parsedQueryParams;
			if (Object.keys(queryParams).length) {
				this.router.navigate(['my-swarm'], { queryParams });
			}
		}
	}
}
